import { baseModalLayoutDriverFactory } from '../BaseModalLayout/BaseModalLayout.legacy.driver';

export const customModalLayoutDriverFactory = ({ element, eventTrigger }) => {
  return {
    ...baseModalLayoutDriverFactory({ element, eventTrigger }),

    /** Returns if the modal content has padding */
    hasContentPadding: async () =>
      (await element.getAttribute('data-contentpadding')) === 'true',
  };
};
